import React from "react";
import { useState } from 'react';
import {
  createBrowserRouter,
  RouteProvider,
  Route,
  Link, Routes
} from 'react-router-dom';

function App() {

  return (
      <Routes>
        <Route path="/" element={<HomePageRoute />} />
        <Route path="/privacy" element={<PrivacyRoute />} />
      </Routes>

  );
}

function HomePageRoute() {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  function handleSubmit(e) {
    e.preventDefault();
  }

  function handleHourlyWorthClick() {
    window.hourlyValue(document.getElementById('totalAnnualIncome').value);
    window.minuteValue(document.getElementById('totalAnnualIncome').value);
  }
  function daysInYear(year) {
    return ((year % 4 === 0 && year % 100 > 0) || year % 400 === 0) ? 366 : 365;
  }

  const year = new Date().getFullYear();
  const hrsInCurrentYear = (24 * (daysInYear(year)));



  const [totalAnnualIncome, setTotalAnnualIncome] = useState("0.00")

  function OnChangeTotalAnnualIncomeValue(e) {
    setTotalAnnualIncome(e.target.value)
  }

  const [hourlyValue, setHourlyValue] = useState("0.00");

  const [minuteValue, setMinuteValue] = useState("0.00");

  const [secondsValue, setSecondsValue] = useState("0.00");

  function OnChangeHourlyValue(e) {
    setHourlyValue(parseFloat(e.target.value, 2) / (24 * (daysInYear(new Date().getFullYear()))))
  }

  function OnChangeMinuteValue(e) {
    setMinuteValue(parseFloat(e.target.value, 2) / (24 * (daysInYear(new Date().getFullYear()))) / 60)
  }

  function OnChangeSecondsValue(e) {
    setSecondsValue(parseFloat((parseFloat(e.target.value, 2) / (24 * (daysInYear(new Date().getFullYear()))) / 60) / 60).toFixed(3))
  }

  function OnChangeWorthCalculation(e) {
    OnChangeTotalAnnualIncomeValue(e);
    OnChangeHourlyValue(e);
    OnChangeMinuteValue(e);
    OnChangeSecondsValue(e);
  }

  const [timeForActivityValue, setTimeForActivityValue] = useState("1.00");

  function OnChangeTimeForActivityValue(e) {
    setTimeForActivityValue(e.target.value)
  }

  const [moneySpentOnActivityValue, setMoneySpentOnActivityValue] = useState("0.00");

  function OnChangeMoneySpentOnActivityValue(e) {
    setMoneySpentOnActivityValue(e.target.value)
  }

  const [moneyMadeFromActivityValue, setMoneyMadeFromActivityValue] = useState("0.00");

  function OnChangeMoneyMadeFromActivityValue(e) {
    setMoneyMadeFromActivityValue(e.target.value)
  }
  return(
      <div>
        <div className="container-fluid">


          <div className="px-4 py-5 my-5 pb-1 mb-1 text-center">
            <form id="hourlyCostForm" className="needs-validation" onSubmit={handleSubmit}>
              <h1 className="display-5 fw-bold">Calculate Your Hourly Value</h1>
              <div className="accordion">
                <div className="accordion-item" id="time-value-explanation">
                  <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"  data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                      How to Calculate the Value of Your Time by Anton Daniels
                    </button>
                  </h2>
                  <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#time-value-explanation">
                    <iframe className="youtube-video" src="https://www.youtube.com/embed/lXVfzke_k84?si=PWKv1QT8vEo2BuvH" title="Anton Danels" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    <p>Check out&nbsp;<a href="https://www.youtube.com/@MillionaireMorningShow/featured" target="_blank">The Millionare Morning Show with Anton Daniels</a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mx-auto form-starting">
                <div className="form-group mb-2">
                  <label htmlFor="totalAnnualIncome" className="lead mb-4">Total Annual Income</label>
                  <input autoFocus type="number" value={totalAnnualIncome} onChange={OnChangeWorthCalculation} className="form-control" name="totalAnnualIncome" id="totalAnnualIncome" placeholder="i.e. 50000" min="0.01" step="0.01" required />
                </div>
                <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                  {/* <button type="submit" className="btn btn-primary btn-lg px-4 gap-3 mt-3 mb-3" id="valueCalculator" autofocus onClick={handleHourlyWorthClick}>Calculate</button> */}
                </div>
                <h2 className="lead mb-4">An hour of your time is worth: <span id="hourlyWorthOutput" className="currency">{formatter.format(hourlyValue)}</span></h2>
                <h3 className="lead mb-4">A minute of your time is worth: <span id="minuteWorthOutput" className="currency">{formatter.format(minuteValue)}</span></h3>
                <h2 className="lead mb-4">A second of your time is worth: <span id="secondWorthOutput" className="currency">${secondsValue}</span></h2>
              </div>
            </form>
          </div>


          <form id="activityCostForm" className="needs-validation" onSubmit={handleSubmit}>
            <div className="px-4 py-5 my-5 pt-1 mt-1 text-center">
              <h1 className="display-5 fw-bold">Activity Cost Calculator</h1>
              <div className="col-lg-6 mx-auto">
                <div className="form-group mb-2">
                  <label htmlFor="timeForActivity" className="lead mb-4">Time to be spent on activity (in hours):</label>
                  <input type="number" value={timeForActivityValue} onChange={OnChangeTimeForActivityValue} className="form-control" name="timeForActivity" id="timeForActivity"
                         placeholder="i.e. 10" min="0.5" step="0.5" required />
                </div>

                <h2 className="lead mb-4">Time cost of activity: <span id="timeCostOfActivity" className="currency">{formatter.format(parseFloat(hourlyValue) * timeForActivityValue)}</span></h2>

                <div className="form-group mb-2">
                  <label htmlFor="moneySpentOnActivity" className="lead mb-4">Money spent on activity:</label>
                  <input type="number" value={moneySpentOnActivityValue} onChange={OnChangeMoneySpentOnActivityValue} className="form-control" name="moneySpentOnActivity" id="moneySpentOnActivity"
                         placeholder="i.e. 5.50" min="0.00" step="0.01" />
                </div>

                <div className="form-group">
                  <label htmlFor="moneyMadeFromActivity" className="lead mb-4">Money made from activity:</label>
                  <input type="number" className="form-control" name="moneyMadeFromActivity" id="moneyMadeFromActivity"
                         placeholder="i.e. 10.50" min="0.00" step="0.01" value={moneyMadeFromActivityValue} onChange={OnChangeMoneyMadeFromActivityValue} />
                </div>

                <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                  {/*<button type="submit" className="btn btn-primary btn-lg px-4 gap-3 mt-3 mb-3" id="costCalculator" onclick="
calculateTimeCostOfActivity(document.getElementById('totalAnnualIncome').value,
document.getElementById('timeForActivity').value);

totalCostOfActivity(
  document.getElementById('totalAnnualIncome').value,
  document.getElementById('timeForActivity').value,
  document.getElementById('moneySpentOnActivity').value,
  document.getElementById('moneyMadeFromActivity').value
  );

hoursToRecoverSpentMoney();">Calculate</button>*/}
                </div>

                <h3 className="lead mb-4">Total Cost: <span id="totalCostOfActivity" className="currency">{formatter.format((parseFloat(hourlyValue) * timeForActivityValue + (moneySpentOnActivityValue - moneyMadeFromActivityValue)))}</span></h3>
                <h3 className="lead mb-4">Number of hours to recover amount: <span id="hoursToRecoverMoney" className="currency">{~~(Math.ceil((parseFloat(hourlyValue) * timeForActivityValue + (moneySpentOnActivityValue - moneyMadeFromActivityValue))/(hourlyValue)))}</span></h3>
              </div>
            </div>
          </form>
        </div>
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
          <div className="container-fluid">
            <a className="navbar-brand" href="https://www.youtube.com/@TechCoachRalph" target="_blank">YouTube</a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a className="nav-link" href="https://www.patreon.com/techcoachralph" target="_blank">Patreon</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://www.techcoachingwithralph.com" target="_blank">Website</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://apps.apple.com/us/app/time-cost-calculator/id6477793638" target="_blank">Download iOS App</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://play.google.com/store/apps/details?id=dev.techcoachralph.time_cost_calculator" target="_blank">Download Google Play App</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://www.reddit.com/u/techcoachralph" target="_blank">Reddit</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://www.twitter.com/techcoachralph" target="_blank">Twitter</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://www.facebook.com/profile.php?id=100093562954804" target="_blank">Facebook</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://forms.gle/ad4SPu2GwyuYDVsY9" target="_blank">Leave Feedback</a>
                </li>
                <li className="nav-item">
                  {/*<a className="nav-link" href="/privacy.html" target="_blank">Privacy Policy</a>*/}
                  <Link className="nav-link" to="/privacy" target="_blank">Privacy Policy</Link>

                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
  );
}

function PrivacyRoute() {
      return (
          <div className="container-fluid">
            <div id="privacy">
              <h1>Privacy Policy</h1>
              <h3>Effective Date: May 20, 2024</h3>

              <p>Thank you for choosing to use the Time Cost Calculator app. Your privacy is very important to us. This Privacy Policy explains how we handle your information when you use our app.</p>

              <h2>Information Collection and Use</h2>
              <p><strong>No Data Collection:</strong><br />The Time Cost Calculator app does not collect, store, or share any personal data from its users. We do not require you to provide any personal information to use the app, and we do not collect any data from your device.</p>

              <h2>Third-Party Advertising</h2>
              <p><strong>Third-Party Ads:</strong><br />
                The app contains advertisements served by third-party ad networks. These ads may use cookies and other technologies to collect anonymous data about your device and usage patterns in order to serve relevant ads. This data may include, but is not limited to, your device type, operating system, and general location.
              </p>

              <h2>Third-Party Privacy Policies:</h2>
              <p>Please be aware that our third-party ad partners have their own privacy policies, which govern their use of your information. We encourage you to review the privacy policies of these third-party ad networks to understand their practices and how you can manage your ad preferences.</p>

              <h2>Data Security</h2>
              <p><strong>Local Processing:</strong><br />
                All data processing related to the app’s core functionality occurs on your device. Since no personal data is transmitted to our servers or any third-party services through the core functionality, there is no risk of your personal data being intercepted or accessed by unauthorized parties through our app.</p>

              <h2>Changes to This Privacy Policy</h2>
              <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy within the app. You are advised to review this Privacy Policy periodically for any changes.</p>

              <h2>Contact Us</h2>
              <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>

              <p><strong>Gehy Logistics, LLC</strong><br />
                <a href="mailto:ralph@techcoachingwithralph.com">ralph@techcoachingwithralph.com</a></p>

              <p>Thank you for using the Time Cost Calculator app.</p>
            </div>

          </div>
      );
}

export default App;
